import { Model as ORMModel, attr, many } from 'redux-orm'
import { Types } from '@fedsim/actions'

export class Faction extends ORMModel {
    static get fields() {
      return {
        id: attr(),

        name: attr({ getDefault: () => '' }),
        desc: attr({ getDefault: () => '' }),
        image: attr({ getDefault: () => '' }),

        color: attr({ getDefault: () => '#fff' }),
        backgroundColor: attr({ getDefault: () => '#000' }),

        startDate: attr({ getDefault: () => new Date() }),
        endDate: attr({ getDefault: () => null }),

        brandIds: many({
          to: 'Brand',
          as: 'brands',
          relatedName: 'FactionBrands'
        }),
        leaderIds: many({
          to: 'Wrestler',
          as: 'leaders',
          relatedName: 'FactionLeaders'
        }),
        wrestlerIds: many({
          to: 'Wrestler',
          as: 'wrestlers',
          relatedName: 'FactionWrestlers'
        }),
        managerIds: many({
          to: 'Wrestler',
          as: 'managers',
          relatedName: 'FactionManagers'
        }),
      }
    }

    static reducer(action, Faction, session) {
      let item
      switch (action.type) {
        case Types.RESET:
        case 'RESET_FACTIONS':
          session.Faction.all()
            .toModelArray()
            .forEach(item => item.delete())
          break
        case Types.GENERATE_FACTIONS:
          action?.payload?.forEach(newItem => {
            session.Faction.upsert(newItem)
          })
          break
        case 'ADD_FACTION': {
          item = action.payload.id ? Faction.withId(action.payload.id) : false
          if (!item) {
            Faction.upsert(action.payload)
          }
          break
        }
        case 'UPDATE_FACTION':
          item = Faction.withId(action.payload.id)
          if (item) {
            item.update(action.payload)
          }
          break
        case 'REMOVE_FACTION':
        case 'DELETE_FACTION': {
          Faction.withId(action.payload.id).delete()
          break
        }
      }
    }
}

export default Faction
